var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultSlidePreview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 633 374",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 17@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Preview-not-supported",
    transform: "translate(-760.000000, -274.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(760.000000, 274.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M626.394563,0.725000024 C627.798283,0.725000024 629.068379,1.29265014 629.987584,2.21070538 C630.906772,3.1287432 631.475021,4.39713381 631.475021,5.79819337 L631.475021,5.79819337 L631.475021,366.908682 C631.475021,368.306744 630.905392,369.575528 629.985214,370.494555 C629.065962,371.412657 627.796629,371.981875 626.394563,371.981875 L626.394563,371.981875 L5.80545812,371.981875 C4.40173811,371.981875 3.13164228,371.414225 2.21243678,370.49617 C1.29324872,369.578132 0.725000024,368.309741 0.725000024,366.908682 L0.725000024,366.908682 L0.725000024,5.79819337 C0.725000024,4.40013102 1.29462902,3.13134656 2.21480712,2.21231994 C3.13405905,1.29421833 4.403392,0.725000024 5.80545812,0.725000024 L5.80545812,0.725000024 Z",
    id: "BG-Copy-3",
    stroke: "#B7B7B7",
    strokeWidth: 1.45000005,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-729-Copy-2",
    fill: "#F2F2F2",
    x: 8.70000029,
    y: 8.70000029,
    width: 613.35002,
    height: 282.750009,
    rx: 7.25000024
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(30.150001, 40.600001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(136.600004, 84.322770)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_picture_1786590_000000",
    transform: "translate(0.000000, 2.227233)",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.64896028,0.348500044 L133.275014,0.348500044 C137.55701,0.348500044 140.97814,3.94522516 140.97814,8.0516253 L140.97814,97.0743782 C140.97814,101.356373 137.55701,104.777503 133.275014,104.777503 L8.64896028,104.777503 C4.36696514,104.777503 0.945835031,101.356373 0.945835031,97.0743782 L0.945835031,8.0516253 C0.945835031,3.94522516 4.36696514,0.348500044 8.64896028,0.348500044 Z M53.1567117,33.0474511 L78.1518126,66.4308022 L95.9534632,42.4666514 L135.670414,95.5395532 L135.670414,8.2336003 C135.670414,6.86290076 134.645221,5.83776522 133.274579,5.83776522 L8.64852528,5.83776522 C7.44775124,5.83776522 6.42248521,6.86295876 6.42248521,8.2336003 L6.42248521,95.5395532 L53.1559867,33.0532511 L53.1567117,33.0474511 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.123503,13.8741005 C108.116064,13.8741005 112.907879,18.6659156 112.907879,24.6584758 C112.907879,30.651036 108.116064,35.6127912 102.123503,35.6127912 C96.1309432,35.6127912 91.169188,30.645381 91.169188,24.6584758 C91.169188,18.6659156 96.1365982,13.8741005 102.123503,13.8741005 Z M102.123503,19.1813907 C105.034813,19.1813907 107.600589,21.7471657 107.600589,24.6584758 C107.600589,27.7397259 105.034813,30.135561 102.123503,30.135561 C99.0422533,30.135561 96.6464182,27.7397259 96.6464182,24.6584758 C96.6464182,21.7471657 99.0422533,19.1813907 102.123503,19.1813907 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(84.249347, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4101274,-2.5 C26.7009774,-2.46932124 32.0824958,-0.242369147 36.5707928,4.18012788 C39.6170548,7.41895869 41.4757482,10.7117435 42.4410415,14.3500809 C42.9435501,16.2552107 43.1955874,18.2606393 43.1955874,20.362689 C43.1342764,26.7817285 40.9043954,32.1599316 36.5167921,36.639498 C35.8633933,37.2799681 35.2299018,37.8403805 34.5790145,38.3661438 C31.2429194,41.0130167 27.4798644,42.582449 23.2644059,43.0835816 C22.2858454,43.2042915 21.2771043,43.265119 20.2424874,43.265119 C18.9604808,43.265119 17.7083819,43.1880684 16.486032,43.0347399 C15.4805519,42.858928 14.5764596,42.646048 13.6842798,42.3823327 C10.1016172,41.3075227 6.88571151,39.4004406 4.04913639,36.6382708 C-0.387983678,31.9467441 -2.52887759,26.5285388 -2.49999922,20.2748522 C-2.4994692,18.1103638 -2.22783629,16.0691695 -1.6934815,14.1496016 C-0.712370161,10.437445 1.24507407,7.11475882 4.20341796,4.18709618 C8.69563283,-0.274489184 14.0996578,-2.5 20.4101274,-2.5 Z",
    id: "Path",
    stroke: "#F2F2F2",
    strokeWidth: 5,
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F2F2F2",
    points: "16.9263474 4.663489 16.9263474 24.983489 23.7701474 24.983489 23.7701474 4.663489"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F2F2F2",
    points: "23.8130474 29.429489 16.9653474 29.429489 16.9653474 36.062289 23.8130474 36.062289"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-729-Copy-2",
    fillOpacity: 0.8,
    fill: "#DDDDDD",
    opacity: 0.908179874,
    x: 0,
    y: 0,
    width: 408.900013,
    height: 282.750009,
    rx: 7.25000024
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultSlidePreview);
export default __webpack_public_path__ + "static/media/default_slide_preview.eddf340b4a9c83e61da4e89c753878b4.svg";
export { ForwardRef as ReactComponent };